import { SMEQCUser } from '@data-access/submissions/types';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';

const _smeEntityConfig = () =>
  entityConfig({
    collection: '_sme',
    entity: type<SMEQCUser>(),
    selectId: (entity) => entity.id,
  });

const _qcEntityConfig = () =>
  entityConfig({
    collection: '_qc',
    entity: type<SMEQCUser>(),
    selectId: (entity) => entity.id,
  });

/**
 * Converts object with numeric keys to array
 */
function convertObjectToArray(
  data: Record<string, SMEQCUser> | SMEQCUser[],
): SMEQCUser[] {
  if (Array.isArray(data)) {
    return data;
  }
  return Object.values(data);
}

export const withSMEQCEntities = () => {
  return signalStoreFeature(
    withEntities(_smeEntityConfig()),
    withEntities(_qcEntityConfig()),
    withMethods(({ ...store }) => ({
      setSMEList: (data: Record<string, SMEQCUser> | SMEQCUser[]) => {
        const arrayData = convertObjectToArray(data);
        return patchState(store, setAllEntities(arrayData, _smeEntityConfig()));
      },
      setQCList: (data: Record<string, SMEQCUser> | SMEQCUser[]) => {
        const arrayData = convertObjectToArray(data);
        return patchState(store, setAllEntities(arrayData, _qcEntityConfig()));
      },
    })),
  );
};
